<template>
  <table class="trades-table">
    <thead>
      <tr>
        <th>{{ $t('trade.holdings-detail-page.table-date') }}</th>
        <th>{{ $t('trade.holdings-detail-page.table-type') }}</th>
        <th>{{ $t('trade.holdings-detail-page.table-amount') }}</th>
        <th>{{ $t('trade.holdings-detail-page.table-price') }}</th>
      </tr>
    </thead>
    <tbody v-if="tradeList.length">
      <tr v-for="trade in tradeList" :key="trade.id">
        <td>{{ trade.time | formatDate }}</td>
        <td class="action">
          <OrderActionName :action="trade.action" />
        </td>
        <td>{{ trade.quantity }}</td>
        <td>{{ trade.price | floatNum(stock) }}</td>
      </tr>
    </tbody>
    <NoData v-else-if="!loading" :text="$t('quote.no-data')" />
  </table>
</template>
<script>
import OrderActionName from 'mod/TextFields/OrderActionName'
import NoData from 'com/NoData'
import { mapGetters } from 'vuex'

export default {
  name: 'TradeTable',
  components: {
    NoData,
    OrderActionName
  },
  props: {
    trades: Array,
    loading: Boolean,
    stock: Object
  },
  computed: {
    ...mapGetters(['isIb']),
    tradeList() {
      return (this.trades || [])
        .map((t, idx) => {
          const trade = {
            action: t.action
          }
          if (this.isIb) {
            trade.time = t.endTime
            trade.quantity = t.quantity
            trade.price = t.avgPrice
          } else {
            trade.time = t.tradeDate
            trade.quantity = t.filledQty
            trade.price = t.price
          }
          trade.id = trade.time + '_' + idx
          return trade
        })
        .sort((a, b) => b.time - a.time)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';

.trades-table {
  width: 100%;
  flex: 1;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  tr {
    display: flex;
    justify-content: space-between;
  }
  th,
  td {
    overflow: hidden;
    &:nth-child(1) {
      flex: 5;
      text-align: left;
    }
    &:nth-child(2) {
      flex: 2;
      text-align: center;
    }
    &:nth-child(3) {
      flex: 3;
      text-align: right;
    }
    &:nth-child(4) {
      flex: 4;
      text-align: right;
    }
  }
  tbody {
    flex: 1;
    overflow-y: auto;
    tr {
      &:nth-child(2n + 1) {
        background-color: var(--divide-color);
      }
    }
  }
}
</style>
